import React from "react";
import ReactDOM from "react-dom/client";
import "./app.css";
import App from "./app";
import registerServiceWorker from "./registerServiceWorker";
import { Provider } from "react-redux";
import store from './store/Store'
import OtpModal from "./components/layout/modal/ConfirmOtpModal";
import ConfirmPasswordModal from "./components/layout/modal/ConfirmPasswordModal";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>   
    <Provider store={store}>
      <App/>
      <OtpModal/>
      <ConfirmPasswordModal/>
    </Provider>
  </React.StrictMode>
);
registerServiceWorker();
